module.exports = __webpack_public_path__ + "img-front/ya.6a8f7d75.png";